module.exports = __webpack_public_path__ + "static/media/image_part_010.c2680343.jpg";